import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const recursos = {
	state: {
		recursos: '',
		talleresOrientacion: '',
		testimonialesOrientacion: ''
	},
	getters: {
		getRecursos: state => state.recursos,
		getTalleresOrientacion: state => state.talleresOrientacion,
		getTestimonialesOrientacion: state => state.testimonialesOrientacion,
	},
	actions: {
		requestRecursos: function ({ commit, dispatch }, type) {
			if (type == null) {
				return
			}
			return new Promise((resolve, reject) => {
				axios.get(`/api/${type}/dameRecursosUsuario`).then(response => {
					if (response.data.status == 0) {
						commit('setRecursos', response.data.datos)
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						
						// commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});

		},
		requestTalleresOrientacion: function ({ commit, dispatch }, type) {
			if (type == null) {
				return
			}
			return new Promise((resolve, reject) => {
				axios.get(`/api/${type}/dameTalleresOrientacionUsuario`).then(response => {
					if (response.data.status == 0) {
						commit('setTalleres', response.data.datos)
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						// commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestTestimonialesOrientacion: function ({ commit, dispatch }, type) {
			if (type == null) {
				return
			}
			return new Promise((resolve, reject) => {
				axios.get(`/api/${type}/dameTestimonialesOrientacionUsuario`).then(response => {
					if (response.data.status == 0) {
						commit('setTestimoniales', response.data.datos)
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						// commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		}
	},
	mutations: {
		setRecursos: function (state, data) {
			state.recursos = data;
		},
		setTalleres: function (state, data) {
			state.talleresOrientacion = data;
		},
		setTestimoniales: function (state, data) {
			state.testimonialesOrientacion = data;
		}
	}
}

export default recursos;



// WEBPACK FOOTER //
// ./src/store/recursos.js